import { defineComponent, openBlock, createElementBlock, createVNode, unref, withCtx, Fragment, renderList, toDisplayString, createCommentVNode, createBlock, createElementVNode, createTextVNode } from "vue";
import { CdrList, CdrLink } from "@rei/cedar";
const _hoisted_1 = {
  "aria-labelledby": "features-label",
  class: "product-features"
};
const _hoisted_2 = {
  key: 0,
  "data-ui": "product-origin",
  class: "product-features__origin"
};
const _hoisted_3 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductFeatures",
  props: {
    brandCategory: {
      default: void 0
    },
    features: {},
    origin: {
      default: ""
    },
    productLine: {
      default: void 0
    },
    prop65: {
      default: void 0
    },
    sellingCopy: {
      default: ""
    }
  },
  emits: ["metricsClick", "modalOpen"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    function handleBrandCategoryClick(event) {
      emit("metricsClick", {
        linkName: "right rail-view all brand category products",
        event
      });
    }
    function handleProp65Click() {
      var _a;
      emit("modalOpen", {
        label: "California Proposition 65 warning",
        labelIsTitle: true,
        modalContent: "Prop65Modal",
        modalProps: {
          message: (_a = props.prop65) == null ? void 0 : _a.message
        },
        id: "prop-65-modal"
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("section", _hoisted_1, [createVNode(unref(CdrList), {
        "data-ui": "product-features-list",
        modifier: "unordered",
        class: "product-features__list"
      }, {
        default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.features, (feature, index) => {
          return openBlock(), createElementBlock("li", {
            key: index
          }, toDisplayString(feature), 1);
        }), 128))]),
        _: 1
      }), _ctx.origin ? (openBlock(), createElementBlock("p", _hoisted_2, toDisplayString(_ctx.origin), 1)) : createCommentVNode("", true), _ctx.sellingCopy ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: "product-features__selling-copy",
        innerHTML: _ctx.sellingCopy
      }, null, 8, _hoisted_3)) : createCommentVNode("", true), _ctx.prop65 ? (openBlock(), createBlock(unref(CdrLink), {
        key: 2,
        "aria-haspopup": "dialog",
        class: "product-features__prop65",
        "data-ui": "product-prop65",
        tag: "button",
        type: "button",
        onClick: handleProp65Click
      }, {
        default: withCtx(() => _cache[1] || (_cache[1] = [createElementVNode("span", null, [createTextVNode(" Important "), createElementVNode("strong", {
          class: "product-features--strong"
        }, "WARNING"), createTextVNode(" for California residents ")], -1)])),
        _: 1,
        __: [1]
      })) : createCommentVNode("", true), _ctx.productLine && _ctx.productLine.url && _ctx.productLine.label ? (openBlock(), createBlock(unref(CdrLink), {
        key: 3,
        "data-ui": "product-line-url",
        href: _ctx.productLine.url,
        class: "product-features__product-line-url"
      }, {
        default: withCtx(() => [createElementVNode("span", null, toDisplayString(_ctx.productLine.label), 1)]),
        _: 1
      }, 8, ["href"])) : createCommentVNode("", true), _ctx.brandCategory ? (openBlock(), createBlock(unref(CdrLink), {
        key: 4,
        "data-ui": "brand-and-category-link",
        href: _ctx.brandCategory.link,
        class: "product-features__brand-category",
        onClick: _cache[0] || (_cache[0] = ($event) => handleBrandCategoryClick($event))
      }, {
        default: withCtx(() => [createElementVNode("span", null, "View all " + toDisplayString(_ctx.brandCategory.name), 1)]),
        _: 1
      }, 8, ["href"])) : createCommentVNode("", true)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductFeatures2.mjs.map
